import * as actions from './taxSetting/actions'
import * as mutations from './taxSetting/mutations'
import * as getters from './taxSetting/getters'

import { dataProps } from './taxSetting/properties'

const state = {
    props: [JSON.parse(JSON.stringify(dataProps))],
    deletedItems: []
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/taxSetting.js